export enum Banks {
  KNAB = <any>'Knab',
  ABN = <any>'Abn Amro'
}


// WEBPACK FOOTER //
// ./src/app/shared/models/Banks.enum.ts